module.exports = __webpack_public_path__ + "front/img/27_12.cd132b38.png";